import { PrintButtonView } from '../data-request/data-request-header/components/print-button.component';
import { AmrPrintButtonView } from '../amr-data-request/amr-print-button.component';
import { useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';

export const PrintButtonContainerComponent = () => {
    const { isAmr } = useAssignedAppTypeContext();

    if (!isAmr) {
        return <PrintButtonView />;
    }

    return <AmrPrintButtonView />;
};
